import PropTypes from 'prop-types';
import React from 'react';

import Column, * as ColumnSizes from '../Column'
import ColumnWrapper from '../ColumnWrapper'

import LabeledInput from './LabeledInput'
import LabeledSelect from './LabeledSelect'

import countries from 'i18n-iso-countries'

import {getFormLabels} from '../../selectors/Forms'

const genderOptions = [
    {value: 'keine Angabe', label: "keine Angabe"},
    {value: "Herr", label: "Herr"},
    {value: "Frau", label: "Frau"},
    {value: "Divers", label: "Divers"},
]

const countryDataPrepend = [
    {
        value: "DE",
        label: "Deutschland"
    },
    {
        value: "AT",
        label: "Österreich"
    },
    {
        value: "CH",
        label: "Schweiz"
    },
    {
        value: "GB",
        label: "England"
    },
    {
        value: "NL",
        label: "Niederlande"
    }
]

const prependKeys = ["DE", "AT", "CH", "GB", "NL"]

const countryData = countries.getNames("de")
const countryOptions = [...countryDataPrepend, ...Object.keys(countryData).filter(key => {
    return !prependKeys.includes(key)
}).map((key) => {
    return {
        value: key,
        label: countryData[key]
    }
})]

function AddressForm(props) {

    const formLabels = getFormLabels(props.labelSetId)

    /* const recommendedAccountRow = props.showRecommendedAccount ? <ColumnWrapper>
         <Column columnWidth={ColumnSizes.SIZE_33}>
             <LabeledSelect
                 forceValidation={props.forceValidation}
                 options={props.recommendedAccountTypes}
                 fieldId="recommendedAccount"
                 label={formLabels.recommendedAccount}
                 isSearchable={false}
                 placeholder=""
                 isOptional={props.optionals.includes("recommendedAccount")}
             />
         </Column>
     </ColumnWrapper> : null*/

    const noteRow = props.showNote ? <ColumnWrapper>
        <Column>
            <LabeledInput forceValidation={props.forceValidation} fieldId="note" label={formLabels.note} isOptional={props.optionals.includes("note")} placeholder="Hinweise, Fragen, Wünsche o.ä."/>
        </Column>
    </ColumnWrapper> : null

    return (
        <form className="cliendata-step__inputs" id={props.id}>
            {/*{recommendedAccountRow}*/}
            <ColumnWrapper>
                <Column columnWidth={ColumnSizes.SIZE_50}>
                    <LabeledInput forceValidation={props.forceValidation} fieldId="company" isOptional={props.optionals.includes("company")} label={formLabels.company}/>
                </Column>
                {props.showTaxID ?
                    <Column columnWidth={ColumnSizes.SIZE_50}>
                        <LabeledInput forceValidation={props.forceValidation} fieldId="vat" isOptional={props.optionals.includes("vat")} label={formLabels.vat}/>
                    </Column>
                    : null}
            </ColumnWrapper>
            <ColumnWrapper>
                <Column columnWidth={ColumnSizes.SIZE_33}>
                    <LabeledSelect
                        options={genderOptions}
                        fieldId="salutation"
                        label={formLabels.salutation}
                        isSearchable={true}
                        forceValidation={props.forceValidation}
                        isOptional={props.optionals.includes("salutation")}
                        placeholder={''}
                    />
                </Column>
                {props.showTitle ?
                    <Column columnWidth={ColumnSizes.SIZE_66}>
                        <LabeledInput forceValidation={props.forceValidation} fieldId="title" isOptional={props.optionals.includes("title")} label={formLabels.title}/>
                    </Column> : null}
            </ColumnWrapper>
            <ColumnWrapper>
                <Column columnWidth={ColumnSizes.SIZE_50}>
                    <LabeledInput forceValidation={props.forceValidation} fieldId="firstName" isOptional={props.optionals.includes("firstName")} label={formLabels.firstName}/>
                </Column>
                <Column columnWidth={ColumnSizes.SIZE_50}>
                    <LabeledInput forceValidation={props.forceValidation} fieldId="lastName" isOptional={props.optionals.includes("lastName")} label={formLabels.lastName}/>
                </Column>
            </ColumnWrapper>
            <ColumnWrapper>
                <Column columnWidth={ColumnSizes.SIZE_66}>
                    <LabeledInput forceValidation={props.forceValidation} fieldId="street" isOptional={props.optionals.includes("street")} label={formLabels.street}/>
                </Column>
                <Column columnWidth={ColumnSizes.SIZE_33}>
                    <LabeledInput forceValidation={props.forceValidation} fieldId="houseNumber" isOptional={props.optionals.includes("houseNumber")} label={formLabels.houseNumber}/>
                </Column>
            </ColumnWrapper>
            <ColumnWrapper>
                <Column columnWidth={ColumnSizes.SIZE_33}>
                    <LabeledInput forceValidation={props.forceValidation} fieldId="zip" isOptional={props.optionals.includes("zip")} label={formLabels.zip}/>
                </Column>
                <Column columnWidth={ColumnSizes.SIZE_66}>
                    <LabeledInput forceValidation={props.forceValidation} fieldId="city" isOptional={props.optionals.includes("city")} label={formLabels.city}/>
                </Column>
            </ColumnWrapper>
            <ColumnWrapper>
                <Column>
                    <LabeledSelect forceValidation={props.forceValidation} options={countryOptions} fieldId="country" label={formLabels.country} isSearchable={true}/>
                </Column>
            </ColumnWrapper>
            <ColumnWrapper>
                <Column>
                    <LabeledInput forceValidation={props.forceValidation} fieldId="emailAddress" isOptional={props.optionals.includes("emailAddress")} label={formLabels.emailAddress} placeholder="muster@adresse.de"/>
                </Column>
            </ColumnWrapper>
            <ColumnWrapper>
                <Column>
                    <LabeledInput forceValidation={props.forceValidation} fieldId="phone" isOptional={props.optionals.includes("phone")} label={formLabels.phone} placeholder="z.B. 0160 1234567"/>
                </Column>
            </ColumnWrapper>
            {noteRow}
        </form>
    );
}

AddressForm.propTypes = {
    forceValidation: PropTypes.bool,
    showRecommendedAccount: PropTypes.bool,
    recommendedAccountTypes: PropTypes.array,
    showNote: PropTypes.bool,
    showTitle: PropTypes.bool,
    showTaxID: PropTypes.bool,
    optionals: PropTypes.array,
    labelSetId: PropTypes.string
};

AddressForm.defaultProps = {
    forceValidation: false,
    labelSetId: "",
    showRecommendedAccount: false,
    showNote: false,
    showTitle: true,
    recommendedAccountTypes: [],
    optionals: ["note", "title", "company", "vat"]
};

export default AddressForm



/** WEBPACK FOOTER **
 ** ./src/components/forms/AddressForm.js
 **/